export default function SwapSuccessNetwork({ formData }) {
  return (
    <div className="transfers__notification transfers__notification_success">
      <span>
        Your wallet is connected to the {formData.routeFrom.name} network
      </span>
    </div>
  );
}
